import { Tag } from '../Tag';
import { TagSelector } from './types';
import FlexGrid from '../FlexGrid';

type TagsSelectorListProps = {
	disable?: boolean;
	selectedIds?: number[];
	list: TagSelector[];
	onClick?: (tagId: unknown) => void;
};

const TagsSelectorList = ({ disable, selectedIds, list, onClick }: TagsSelectorListProps) => {
	return (
		<FlexGrid
			gap='scanty'
			wrap
		>
			{list.map(({ id, value }) => {
				const isSelected = Array.isArray(selectedIds) ? selectedIds.some((tagId) => tagId === id) : false;

				return (
					<Tag
						disabled={disable || isSelected}
						onClick={onClick}
						id={id}
					>
						{value}
					</Tag>
				);
			})}
		</FlexGrid>
	);
};

export { TagsSelectorList };
